/**
 * Returns a sorted copy of the array; sorted by the property and direction
 * @param array
 * @param sortProperty can include nested properties: prop1.prop2.prop3
 * @param sortDirection "ASC" or "DESC" or "AUTO"
 * @returns
 */
export const sortArray = <T>(array: T[], sortProperty: string, sortDirection: "ASC" | "DESC" | "AUTO") => {
	const sortProperties = sortProperty.split(".").filter((p) => p !== "")
	const sorted = [...array].sort((a: any, b: any) => {
		for (const sortProp of sortProperties) {
			a = a[sortProp]
			b = b[sortProp]
		}
		a = a || ""
		b = b || ""
		return a === b ? 0 : a < b ? -1 : 1
	})
	if (sortDirection === "AUTO") {
		// if at least one item is in a different order after sorting, return in this order
		for (let i = 0; i < sorted.length; i++) {
			if (sorted[i] !== array[i]) {
				return sorted
			}
		}
		// if all items are in the same order after sorting, reverse
		return sorted.reverse()
	} else if (sortDirection === "DESC") {
		return sorted.reverse()
	}
	return sorted
}
